<template>
  <div>
    <v-container :class="{ 'd-none': diagramLoaded }">
      <v-row class="d-flex pa-0">
        <v-col cols="12" class="pa-0 pb-4">
          <v-skeleton-loader class="pa-0" type="heading"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-skeleton-loader class="pa-0" type="image"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-skeleton-loader
            class="pa-0 pt-4"
            type="sentences"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <div class="d-flex flex-row" :class="{ 'd-none': !diagramLoaded }">
      <div
        class="container pa-0"
        id="cont-ainer"
        style="border-top: solid 1px rgba(0, 0, 0, 0.064)"
      >
        <div
          class="content pa-0"
          style="
            border-top: solid 1px rgba(0, 0, 0, 0.064);
            border-bottom: solid 1px rgba(0, 0, 0, 0.064);
          "
        >
          <div
            id="mindmapEditorDiv"
            :class="{ 'd-none': !diagramLoaded }"
            style="
              border-left: solid 1px rgba(0, 0, 0, 0.064);
              width: 100%;
              z-index: 0 !important;
            "
          ></div>
        </div>
      </div>
      <div
        class="d-flex flex-column"
        style="
          border-top: solid 1px rgba(0, 0, 0, 0.064);
          border-right: solid 1px rgba(0, 0, 0, 0.064);
          border-bottom: solid 1px rgba(0, 0, 0, 0.064);
        "
      >
        <BaseBtn
          id="zoomInBtn"
          class="pa-0"
          :class="{ 'd-none': !diagramLoaded }"
          type="tertiary"
          @click="handleZoomIn"
        >
          <span class="d-flex" style="justify-content: center !important">
            <simple-svg
              :src="require('@/assets/zoomInIcon.svg')"
              width="32px"
              height="32px"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : '#A8A8A8'"
            /> </span
        ></BaseBtn>
        <BaseBtn
          id="zoomOutBtn"
          class="pa-0"
          :class="{ 'd-none': !diagramLoaded }"
          type="tertiary"
          @click="handleZoomOut"
        >
          <span class="d-flex" style="justify-content: center !important">
            <simple-svg
              :src="require('@/assets/zoomOutIcon.svg')"
              width="32px"
              height="32px"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : '#A8A8A8'"
            /> </span
        ></BaseBtn>
        <BaseBtn
          id="zoomToFitBtn"
          class="pa-0"
          :class="{ 'd-none': !diagramLoaded }"
          type="tertiary"
          @click="handleZoomToFit"
        >
          <span class="d-flex" style="justify-content: center !important">
            <simple-svg
              :src="require('@/assets/zoomToFitIcon.svg')"
              width="40px"
              height="40px"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : '#A8A8A8'"
            /> </span
        ></BaseBtn>
        <v-spacer></v-spacer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import * as go from 'gojs'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'
import aiWorkflowApi from '@/services/aiworkflowApi.js'
import BaseBtn from '@/components/BaseBtn.vue'
export default {
  name: 'MindmapEditor',
  components: { BaseBtn },
  data: () => ({
    gojsMindmap: null,
    mindmapModel: null,
    lastDirection: 'left',
    colorPalette: [
      '#db34ac',
      '#2ecc71',
      '#9b59b6',
      '#34495e',
      '#f1c40f',
      '#e67e22',
      '#e74c3c',
      '#95a5a6',
      '#7f8c8d',
      '#d35400',
      '#c0392b',
      '#8e44ad',
      '#2980b9',
      '#3fdb34',
      '#1abc9c',
    ],
    usedColors: [],
    diagramLoaded: false,
  }),
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.initGojsMindmap()
    this.setEditorHeight()
    this.addEvents()
    this.$root.$on('updateDiagramTheme', () => {
      this.renderGojsMindmap()
    })
    this.$root.$on('saveEditedMindmap', () => {
      this.saveEditedMindmap()
    })
    this.$root.$on('handleDiscardChanges', () => {
      this.handleDiscardChanges()
    })
  },
  beforeDestroy() {
    this.$root.$off('updateDiagramTheme')
    this.$root.$off('saveEditedMindmap')
    this.$root.$off('handleDiscardChanges')
    this.diagramLoaded = false
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.dark
    },
  },
  methods: {
    zoomToFitness() {
      this.gojsMindmap.zoomToFit()
    },
    setContainerHeight() {
      let str = this.gojsMindmap.div.style.height
      let num = parseInt(str, 10)
      let height = Math.floor(num * 0.85)
      document.getElementById('cont-ainer').style.height = `${height}px`
    },
    initGojsMindmap() {
      const $ = go.GraphObject.make
      const _this = this

      function mouseEnter(e, obj) {
        let shape = obj.findObject('SHAPE')
        shape.strokeWidth = 5
        shape.stroke = 'dodgerblue'
      }

      function mouseLeave(e, obj) {
        var shape = obj.findObject('SHAPE')
        shape.strokeWidth = 4
        shape.stroke = obj.data.brush
      }

      this.gojsMindmap = new go.Diagram('mindmapEditorDiv', {
        'commandHandler.copiesTree': true,
        'commandHandler.copiesParentKey': true,
        'commandHandler.deletesTree': true,
        'draggingTool.dragsTree': true,
        'undoManager.isEnabled': true,
        // initialDocumentSpot: go.Spot.BottomCenter,
        initialContentAlignment: go.Spot.BottomCenter,
      })
      this.gojsMindmap.padding = new go.Margin(230, 130, 130, 130)

      this.gojsMindmap.addDiagramListener('InitialLayoutCompleted', (e) => {
        setTimeout(function () {
          e.diagram.zoomToFit()
        }, 1000)
      })
      this.gojsMindmap.addDiagramListener('Modified', () => {
        var saveButtonBtn = document.getElementById('saveButton')
        if (saveButtonBtn) saveButtonBtn.disabled = !this.gojsMindmap.isModified
        var discardChangesBtn = document.getElementById('discardChanges')
        if (discardChangesBtn)
          discardChangesBtn.disabled = !this.gojsMindmap.isModified
        var idx = document.title.indexOf('*')
        if (this.gojsMindmap.isModified) {
          if (idx < 0) document.title += '*'
        } else {
          if (idx >= 0) document.title = document.title.slice(0, idx)
        }
      })

      this.gojsMindmap.nodeTemplate = $(
        go.Node,
        'Auto',
        {
          selectionObjectName: 'SHAPE',
          mouseEnter: mouseEnter,
          mouseLeave: mouseLeave,
        },
        $(
          go.Shape,
          'RoundedRectangle',
          {
            name: 'SHAPE',
            strokeWidth: 4,
            portId: '',
            fromSpot: go.Spot.LeftRightSides,
            toSpot: go.Spot.LeftRightSides,
            stretch: go.GraphObject.Horizontal,
            margin: 8,
            cursor: 'pointer',
          },
          new go.Binding('fill', 'brush', function (b) {
            return _this.applyOpacity(b, 0.2)
          }),
          new go.Binding('stroke', 'brush'),
          new go.Binding('fromSpot', 'dir', (d) => this.spotConverter(d, true)),
          new go.Binding('toSpot', 'dir', (d) => this.spotConverter(d, false))
        ),
        $(
          go.TextBlock,
          {
            name: 'TEXT',
            minSize: new go.Size(30, 15),
            editable: true,
            width: 150,
            margin: 16,
            textAlign: 'center',
            cursor: 'pointer',
            font: '12pt Rubik',
          },
          new go.Binding('text', 'text').makeTwoWay(),
          new go.Binding('scale', 'scale').makeTwoWay(),
          new go.Binding('font', 'font').makeTwoWay(),
          new go.Binding('stroke', 'textColor')
        ),
        new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
          go.Point.stringify
        ),
        new go.Binding('locationSpot', 'dir', (d) =>
          this.spotConverter(d, false)
        )
      )
      class CustomTextEditingTool extends go.TextEditingTool {
        doActivate() {
          super.doActivate()
          const textColor = _this.isDarkTheme ? 'white' : 'black'
          let textarea = this.currentTextEditor
          if (textarea) {
            textarea.u.style.color = textColor
          }
        }
      }
      this.gojsMindmap.toolManager.textEditingTool = new CustomTextEditingTool()

      function addNodeButtonConfig(align, focusAlign) {
        return {
          name: align === go.Spot.Right ? 'BUTTON_RIGHT' : 'BUTTON_LEFT',
          'ButtonBorder.figure': 'Circle',
          'ButtonBorder.fill': 'white',
          'ButtonBorder.stroke': '#0f21a1',
          'ButtonBorder.strokeWidth': 4,
          _buttonFillOver: 'white',
          _buttonStrokeOver: 'dodgerblue',
          _buttonFillPressed: 'lightgray',
          alignment: align,
          alignmentFocus: focusAlign,
          click: _this.addNodeAndLink,
          width: 36,
          height: 36,
        }
      }
      const plusLine = {
        width: 12,
        height: 12,
        stroke: 'black',
        strokeWidth: 2,
      }

      let buttonConfigRight = addNodeButtonConfig(go.Spot.Right, go.Spot.Left)
      let buttonConfigLeft = addNodeButtonConfig(go.Spot.Left, go.Spot.Right)

      this.gojsMindmap.nodeTemplate.selectionAdornmentTemplate = $(
        go.Adornment,
        'Spot',
        $(
          go.Panel,
          'Auto',
          $(go.Placeholder, { margin: new go.Margin(2, 2, 0, 2) })
        ),
        $(
          'Button',
          buttonConfigRight,
          $(go.Shape, 'PlusLine', plusLine),
          new go.Binding('ButtonBorder.stroke', 'brush'),
          new go.Binding('visible', '', (obj) => {
            const data = obj.part.adornedPart.data
            const locX = parseFloat(data.loc.split(' ')[0])
            return data.key === 0 || locX >= 0
          }).ofObject()
        ),
        $(
          'Button',
          buttonConfigLeft,
          $(go.Shape, 'PlusLine', plusLine),
          new go.Binding('ButtonBorder.stroke', 'brush'),
          new go.Binding('visible', '', (obj) => {
            const data = obj.part.adornedPart.data
            const locX = parseFloat(data.loc.split(' ')[0])
            return data.key === 0 || locX <= 0
          }).ofObject()
        )
      )
      this.gojsMindmap.nodeTemplate.contextMenu = $(
        'ContextMenu',
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.copy')
          ),
          {
            click: (e, obj) => e.diagram.commandHandler.copySelection(),
          }
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.delete')
          ),
          {
            click: (e, obj) => e.diagram.commandHandler.deleteSelection(),
          }
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.undo')
          ),
          {
            click: (e, obj) => e.diagram.commandHandler.undo(),
          }
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.redo')
          ),
          {
            click: (e, obj) => e.diagram.commandHandler.redo(),
          }
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.layout')
          ),
          {
            click: (e, obj) => {
              var adorn = obj.part
              adorn.diagram.startTransaction('Subtree Layout')
              this.layoutTree(adorn.adornedPart)
              adorn.diagram.commitTransaction('Subtree Layout')
            },
          }
        )
      )
      this.gojsMindmap.linkTemplate = $(
        go.Link,
        { routing: go.Link.Orthogonal, corner: 5 },
        {
          fromShortLength: -2,
          toShortLength: -2,
          selectable: false,
        },
        $(
          go.Shape,
          { strokeWidth: 3 },
          new go.Binding('stroke', 'toNode', (n) => {
            if (n.data.brush) return n.data.brush
            return 'black'
          }).ofObject()
        )
      )
      this.gojsMindmap.contextMenu = $(
        'ContextMenu',
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.paste')
          ),
          {
            click: (e, obj) =>
              e.diagram.commandHandler.pasteSelection(
                e.diagram.toolManager.contextMenuTool.mouseDownPoint
              ),
          },
          new go.Binding(
            'visible',
            '',
            (o) =>
              o.diagram &&
              o.diagram.commandHandler.canPasteSelection(
                o.diagram.toolManager.contextMenuTool.mouseDownPoint
              )
          ).ofObject()
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.undo')
          ),
          { click: (e, obj) => e.diagram.commandHandler.undo() },
          new go.Binding(
            'visible',
            '',
            (o) => o.diagram && o.diagram.commandHandler.canUndo()
          ).ofObject()
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.redo')
          ),
          { click: (e, obj) => e.diagram.commandHandler.redo() },
          new go.Binding(
            'visible',
            '',
            (o) => o.diagram && o.diagram.commandHandler.canRedo()
          ).ofObject()
        ),
        $(
          'ContextMenuButton',
          $(
            go.TextBlock,
            { font: '12pt Rubik', minSize: new go.Size(30, 15) },
            i18n.t('message.ai.mindmap.mindmapEditor.layout')
          ),
          { click: (e, obj) => this.layoutAll() }
        )
      )

      this.gojsMindmap.addDiagramListener('SelectionMoved', (e) => {
        var rootX = this.gojsMindmap.findNodeForKey(0).location.x
        this.gojsMindmap.selection.each((node) => {
          if (node.data.parent !== 0) return
          var nodeX = node.location.x
          if (rootX < nodeX && node.data.dir !== 'right') {
            this.updateNodeDirection(node, 'right')
          } else if (rootX > nodeX && node.data.dir !== 'left') {
            this.updateNodeDirection(node, 'left')
          }
          this.layoutTree(node)
        })
      })

      this.gojsMindmap.addDiagramListener('AnimationFinished', function (e) {
        if (!_this.diagramLoaded) {
          _this.diagramLoaded = true
        }
      })

      this.renderGojsMindmap()
    },
    addEvents() {
      const __this = this
      document.addEventListener('keydown', this.eraseTextArea)
      window.addEventListener('resize', function () {
        __this.setEditorHeight()
      })
    },
    eraseTextArea() {
      const nodeText =
        this.gojsMindmap.toolManager.textEditingTool.textBlock?.text
      if (nodeText) {
        this.gojsMindmap.toolManager.textEditingTool.textBlock.text = ''
      }
    },
    rgbaToHex(rgba) {
      const result =
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?\)$/.exec(rgba)

      let r = parseInt(result[1])
      let g = parseInt(result[2])
      let b = parseInt(result[3])
      let a = result[4] ? parseFloat(result[4]) * 255 : 255

      const toHex = (n) => n.toString(16).padStart(2, '0')

      return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(Math.round(a))}`
    },
    spotConverter(dir, from) {
      if (dir === 'left') {
        return from ? go.Spot.Left : go.Spot.Right
      } else {
        return from ? go.Spot.Right : go.Spot.Left
      }
    },
    changeTextSize(obj, factor) {
      var adorn = obj.part
      adorn.diagram.startTransaction('Change Text Size')
      var node = adorn.adornedPart
      var tb = node.findObject('TEXT')
      tb.scale *= factor
      adorn.diagram.commitTransaction('Change Text Size')
    },
    toggleTextWeight(obj) {
      var adorn = obj.part
      adorn.diagram.startTransaction('Change Text Weight')
      var node = adorn.adornedPart
      var tb = node.findObject('TEXT')
      var idx = tb.font.indexOf('bold')
      if (idx < 0) {
        tb.font = 'bold ' + tb.font
      } else {
        tb.font = tb.font.slice(idx + 5)
      }
      adorn.diagram.commitTransaction('Change Text Weight')
    },
    updateNodeDirection(node, dir) {
      this.gojsMindmap.model.setDataProperty(node.data, 'dir', dir)
      var chl = node.findTreeChildrenNodes()
      while (chl.next()) {
        this.updateNodeDirection(chl.value, dir)
      }
    },
    addNodeAndLink(e, obj) {
      const { part: adorn } = obj
      const { adornedPart: oldnode } = adorn
      const { data: olddata } = oldnode
      const diagram = adorn.diagram

      diagram.startTransaction('Add Node')

      const dir =
        olddata.key === 0
          ? obj.name === 'BUTTON_LEFT'
            ? 'left'
            : 'right'
          : olddata.dir
      const brush = olddata.key === 0 ? this.sortNewNodeColor() : olddata.brush

      const newdata = {
        text: '',
        brush,
        dir,
        parent: olddata.key,
      }

      diagram.model.addNodeData(newdata)
      this.layoutTree(oldnode)
      diagram.commitTransaction('Add Node')

      var newnode = diagram.findNodeForData(newdata)
      if (newnode !== null) diagram.scrollToRect(newnode.actualBounds)
      // this.layoutAll()
    },
    layoutTree(node) {
      if (node.data.key === 0) {
        this.layoutAll()
      } else {
        var parts = node.findTreeParts()
        this.layoutAngle(parts, node.data.dir === 'left' ? 180 : 0)
      }
    },
    layoutAngle(parts, angle) {
      var layout = go.GraphObject.make(go.TreeLayout, {
        angle: angle,
        arrangement: go.TreeLayout.ArrangementFixedRoots,
        nodeSpacing: 5,
        layerSpacing: 20,
        setsPortSpot: false,
        setsChildPortSpot: false,
      })
      layout.doLayout(parts)
    },
    layoutAll() {
      var root = this.gojsMindmap.findNodeForKey(0)
      if (root === null) return
      this.gojsMindmap.startTransaction('Layout')
      // split the nodes and links into two collections
      var rightward = new go.Set(/*go.Part*/)
      var leftward = new go.Set(/*go.Part*/)
      root.findLinksConnected().each((link) => {
        var child = link.toNode
        if (child.data.dir === 'left') {
          leftward.add(root)
          leftward.add(link)
          leftward.addAll(child.findTreeParts())
        } else {
          rightward.add(root)
          rightward.add(link)
          rightward.addAll(child.findTreeParts())
        }
      })
      this.layoutAngle(rightward, 0)
      this.layoutAngle(leftward, 180)
      this.gojsMindmap.commitTransaction('Layout')
    },
    setEditorHeight() {
      const innerHeight = window.innerHeight
      let factor = 75
      const editorHeight = Math.floor((innerHeight / 100) * factor)
      const heightConfig = `${editorHeight}px`
      this.gojsMindmap.div.style.height = heightConfig
      this.setContainerHeight()
      this.gojsMindmap.requestUpdate()
    },
    saveEditedMindmap() {
      this.$root.$emit('loadingSaveButton', true)
      this.mindmapModel = this.gojsMindmap.model.toJson()
      this.gojsMindmap.isModified = false
      const myConvertedModel = this.convertGojsToJson()
      this.updateMindmapData(this.videoId, myConvertedModel)
    },
    load() {
      this.gojsMindmap.model = go.Model.fromJson(this.mindmapModel)
    },
    renderGojsMindmap() {
      const key = 'mindmapString'
      const mindmapString = Storage.getItem(key)
      const convertedString = this.convertJsonToGojs(mindmapString)
      this.mindmapModel = convertedString
      this.load()
      this.layoutAll()
    },
    convertJsonToGojs(jsonConfig) {
      const _this = this
      const config = JSON.parse(jsonConfig)
      const textColor = _this.isDarkTheme ? 'white' : 'black'
      const rootNode = {
        key: 0,
        text: config.theme,
        fill: '#0f21a1',
        brush: '#0f21a1',
        loc: '0 0',
        textColor: textColor,
      }

      let nodeDataArray = []
      nodeDataArray.push(rootNode)

      function addNodes(node, parentKey = null, depth, index, parentColor) {
        let gojsNode = {
          key: nodeDataArray.length,
          text: node.text,
          parent: 0,
          textColor: textColor,
        }
        if (parentKey !== null) {
          gojsNode.parent = parentKey
        }
        if (gojsNode.parent === 0) {
          gojsNode.dir = _this.calcNodeDir()
          gojsNode.brush = _this.colorPalette[index % _this.colorPalette.length]
        } else {
          gojsNode.brush = parentColor
        }
        const color = gojsNode.brush
        _this.usedColors.push(color)
        nodeDataArray.push(gojsNode)

        if (node.children && node.children.length) {
          node.children.forEach((child, index) =>
            addNodes(child, gojsNode.key, depth + 1, index, color)
          )
        }
      }
      if (config.children && config.children.length) {
        config.children.forEach((child, index) =>
          addNodes(child, null, 0, index, null)
        )
      }
      return {
        class: 'go.TreeModel',
        nodeDataArray: nodeDataArray,
      }
    },
    calcLoc(node, depth) {
      const x = depth * 100
      const y = node.index * 50
      return `${x} ${y}`
    },
    calcNodeDir() {
      this.lastDirection = this.lastDirection === 'left' ? 'right' : 'left'
      return this.lastDirection
    },
    calcBrush(index) {
      return this.colorPalette[index] || 'gray'
    },
    applyOpacity(color, opacity) {
      const red = parseInt(color.slice(1, 3), 16)
      const green = parseInt(color.slice(3, 5), 16)
      const blue = parseInt(color.slice(5, 7), 16)
      if (this.isDarkTheme) opacity = 0.7
      return `rgba(${red}, ${green}, ${blue}, ${opacity})`
    },
    convertGojsToJson() {
      const myConvertedModel = this.buildJsonFromDiagram(this.mindmapModel)
      return myConvertedModel
    },
    buildJsonFromDiagram() {
      let rootNode = this.gojsMindmap.findNodeForKey('0')
      let json = this.buildJsonForNode(rootNode, 'root')
      return json
    },

    buildJsonForNode(node, root) {
      const _this = this
      if (node === null) return null
      let jsonObject

      if (root) {
        jsonObject = {
          theme: node.data.text,
          children: [],
        }
      } else {
        jsonObject = {
          text: node.data.text,
          children: [],
        }
      }

      node.findTreeChildrenNodes().each(function (child) {
        let childObject = _this.buildJsonForNode(child)

        if (childObject !== null) {
          jsonObject.children.push(childObject)
        }
      })

      return jsonObject
    },
    sortNewNodeColor() {
      const newColor = this.colorPalette.find(
        (color) => !this.usedColors.includes(color)
      )
      this.usedColors.push(newColor)
      return newColor
    },
    addMindmapToLocalStorage(val) {
      const key = 'mindmapString'
      Storage.setItem(key, val)
    },
    async updateMindmapData(videoId, myConvertedModel) {
      const data = {
        video_id: videoId,
        mindmap: myConvertedModel,
      }
      try {
        await aiWorkflowApi.updateAiWorkFlowData(data)
        const jsonModel = JSON.stringify(myConvertedModel)
        this.addMindmapToLocalStorage(jsonModel)
        this.$root.$emit('renderDiagram', myConvertedModel)
        this.$root.$emit('loadingSaveButton', false)
      } catch (error) {
        console.error(error)
      }
    },
    handleDiscardChanges() {
      if (this.gojsMindmap.isModified) {
        this.renderGojsMindmap()
      }
    },
    handleZoomIn() {
      this.gojsMindmap.commandHandler.increaseZoom(1.5)
    },
    handleZoomOut() {
      this.gojsMindmap.commandHandler.decreaseZoom(0.5)
    },
    handleZoomToFit() {
      this.gojsMindmap.zoomToFit()
    },
  },
}
</script>
<style scoped lang="scss">
.container {
  overflow: hidden;
  position: relative;
}
.content {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
